import { type HttpClient } from '@/application/interfaces/http-client';

import postAddress from './post-address';

const addressesService = (httpClient: HttpClient.Instance) => ({
  postAddress: postAddress(httpClient),
});

export default addressesService;
